import {Component} from 'react';

export class ScrollToTop extends Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./web/js/components/ScrollToTop.js